import PushNotificationsScreenConnector from './PushNotificationsScreenConnector';

export default PushNotificationsScreenConnector;
